import styled from 'styled-components';

import CommonButton from '~/UI/components/atoms/CommonButton';
import ConfigurableModal from '~organisms/ConfigurableModal';

export const Container = styled(ConfigurableModal)(({ theme }) => ({
  '& .modal-content': {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },

  '& .ant-form-item': {
    marginBottom: 0,
  },

  '& .ant-modal-footer': {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10rem',
    marginTop: '50rem',
    fontSize: theme.typography.size20,
  },
}));

export const Header = styled.div(({ theme }) => ({
  fontSize: theme.typography.size24,
  fontWeight: 'bold',
  fontFamily: theme.typography.family.arial,
  display: 'flex',
  gap: '10rem',

  '& .anticon': {
    marginTop: '5rem',
    color: theme.palette.silverFoil,
  },
}));

export const Description = styled.p(({ theme }) => ({
  fontSize: theme.typography.size16,
  fontFamily: theme.typography.family.arial,
}));

export const Required = styled.p(({ theme }) => ({
  marginInline: 0,
  marginBlock: '2rem',
  fontSize: theme.typography.size12,
}));

export const AddressWarning = styled.p(({ theme }) => ({
  margin: 0,
  fontSize: theme.typography.size12,
}));

export const Title = styled.div(({ theme }) => ({
  color: theme.palette.artichoke,
}));

export const LoadingContainer = styled.div({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  background: 'rgba(255, 255, 255, 0.8)',
  zIndex: 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const FooterButton = styled(CommonButton)(({ theme }) => ({
  fontSize: theme.typography.size20,
}));
